export default (props) => (
  /**
   * Icone de lixeira.
   * Geralmente usado para remover coisas criadas.
   */
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.89995 2.12786H4.27495V1.75286C4.27495 1.30727 4.63617 0.946045 5.08177 0.946045H7.4454C7.891 0.946045 8.25222 1.30727 8.25222 1.75286V2.12786H8.62722H11.5818C11.701 2.12786 11.7977 2.22453 11.7977 2.34377V3.52559C11.7977 3.64483 11.701 3.7415 11.5818 3.7415H10.9909H10.6159V4.1165V12.3892C10.6159 12.8348 10.2546 13.196 9.80904 13.196H2.71813C2.27254 13.196 1.91131 12.8348 1.91131 12.3892V4.1165V3.7415H1.53631H0.945401C0.826158 3.7415 0.729492 3.64483 0.729492 3.52559V2.34377C0.729492 2.22453 0.826158 2.12786 0.945401 2.12786H3.89995ZM4.49086 4.92332C3.9574 4.92332 3.52495 5.35577 3.52495 5.88923V10.6165C3.52495 11.15 3.9574 11.5824 4.49086 11.5824C5.02431 11.5824 5.45677 11.15 5.45677 10.6165V5.88923C5.45677 5.35577 5.02431 4.92332 4.49086 4.92332ZM8.03631 4.92332C7.50285 4.92332 7.0704 5.35577 7.0704 5.88923V10.6165C7.0704 11.15 7.50285 11.5824 8.03631 11.5824C8.56977 11.5824 9.00222 11.15 9.00222 10.6165V5.88923C9.00222 5.35577 8.56977 4.92332 8.03631 4.92332Z"
      stroke={props.stroke ? props.stroke : 'currentColor'}
      strokeWidth="0.75"
    />
  </svg>
);
